var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"role":"presentation"}},[_c('hr',_vm._b({staticClass:"flyout-divider",attrs:{"role":"separator","aria-orientation":"horizontal"}},'hr',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }